import { render } from "./ContactView.vue?vue&type=template&id=5ab7781c&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=5ab7781c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab7781c"]])

export default __exports__